/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum GeometryType {
  Unknown = 0,
  Aerodrome = 1,
  Hospital = 2,
  Hotel = 3,
  Motel = 4,
  Mall = 5,
  Restaurant = 6
}
